"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchCall = void 0;
const constants_1 = require("./constants");
async function fetchCall(url, payload, timeout, logger) {
    let timer;
    try {
        logger.debug('Fetch Request:', url, payload);
        const abortController = new AbortController();
        timer = setTimeout(() => {
            abortController.abort();
        }, timeout);
        const response = await fetch(url, {
            headers: new Headers({
                'Authorization': constants_1.AUTH_TOKEN,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }),
            method: 'POST',
            body: JSON.stringify(payload),
            signal: abortController.signal,
            keepalive: false,
        });
        clearTimeout(timer);
        const { status } = response;
        if (status >= 200 && status < 300) {
            logger.debug('Fetch Success:', response);
            return [true];
        }
        logger.debug('Fetch failed:', response);
        // TODO: send error message also
        return [false, { code: status }];
    }
    catch (err) {
        logger.error('Fetch failed:', err);
        if (timer) {
            clearTimeout(timer);
        }
        if (err instanceof Error) {
            return [
                false,
                {
                    code: 'code' in err ? err.code : 0,
                    message: err.message ?? 'Unknown',
                    name: err?.name ?? 'Unknown',
                },
            ];
        }
        return [false, { code: 0 }];
    }
}
exports.fetchCall = fetchCall;
//# sourceMappingURL=fetch.js.map